import script from "./ProductRatingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductRatingModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductRatingModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__